import React from 'react';

const EyeIcon = ({ size = 26, fill = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    {...props}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5819 12.0058C15.5819 13.9858 13.9819 15.5858 12.0019 15.5858C10.0219 15.5858 8.42188 13.9858 8.42188 12.0058C8.42188 10.0258 10.0219 8.42578 12.0019 8.42578C13.9819 8.42578 15.5819 10.0258 15.5819 12.0058Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0037 20.2727C15.5337 20.2727 18.8238 18.1927 21.1138 14.5927C22.0138 13.1827 22.0138 10.8127 21.1138 9.40266C18.8238 5.80266 15.5337 3.72266 12.0037 3.72266C8.47375 3.72266 5.18375 5.80266 2.89375 9.40266C1.99375 10.8127 1.99375 13.1827 2.89375 14.5927C5.18375 18.1927 8.47375 20.2727 12.0037 20.2727Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EyeIcon;
